/**
 * 「어디서 난 건가」 한 줄 — 경보와 이상탐지가 같은 문자열을 쓴다.
 *
 * 목록에 「CO」·「VOC」만 떠 있어 현장도 함체도 알 수 없다는 지적(2026-09-23)에서
 * 나왔다. 서버가 `site_name`·`node_code`·`node_label` 을 함께 내려주므로 화면은
 * 그걸 그대로 조립만 한다 — **id 로 이름을 다시 조회하지 않는다**(목록 한 줄마다
 * 질의가 붙는다).
 */
export interface SubjectFields {
  site_name?: string | null;
  node_code?: string | null;
  node_label?: string | null;
}

/**
 * 「테스트_금산2 · sensor2-01(1층 수변전실)」. 빠진 조각은 조용히 건너뛰고,
 * 아무것도 없으면 빈 문자열 — 호출부가 그때 줄 자체를 그리지 않는다.
 */
export function subjectLine(x: SubjectFields | null | undefined): string {
  if (!x) return "";
  const site = (x.site_name ?? "").trim();
  const code = (x.node_code ?? "").trim();
  const label = (x.node_label ?? "").trim();
  // 라벨이 코드와 같으면 「sensor2-01(sensor2-01)」이 된다 — 한 번만 쓴다.
  const node = code && label && label !== code ? `${code}(${label})` : code || label;
  return [site, node].filter(Boolean).join(" · ");
}
